/* =================================================================
   GBS CONFIGURATOR  v2
   Three-level (Series → Transmission → Package) product page UI.

   VARIANT MAPPING (read-only — do NOT change Shopify variants):
   ─────────────────────────────────────────────────────────────
   UI Series     │ UI Transmission  │ UI Package         │ Shopify option1 │ Shopify option2
   ─────────────────────────────────────────────────────────────────────────────────────────
   BA / BF / FG  │ Manual           │ Standard           │ BA/BF/FG        │ Standard
   BA / BF / FG  │ Manual           │ Cruise + A/C       │ BA/BF/FG        │ Cruise and A/C ready(*)
   BA / BF / FG  │ Manual           │ Turbo Ready        │ BA/BF/FG        │ Turbo ready(*)
   BA / BF / FG  │ Manual           │ Cruise + A/C+Turbo │ BA/BF/FG        │ Cruise A/C and Turbo ready(*)
   BA / BF / FG  │ BTR Automatic    │ (same as Manual)   │ (same variant)  │ (same)
   FG MK1/MK2    │ ZF 6-Speed       │ Standard           │ FG              │ ZF Automatic
   FG MK1/MK2    │ ZF 6-Speed       │ Turbo Ready        │ FG              │ ZF Automatic Turbo ready(*)
   FG MK2        │ any              │ any                │ FG              │ same as FG MK1 + cart prop

   (*) exact spelling differs per product — matched by keyword at runtime.

   Factory harness requirement:
     requiresDonorHarness = isFgMk2 || isZf6Speed
================================================================= */
(function () {
  'use strict';

  var CONTACT_URL = '/pages/contact';

  /* ── Donor harness rule ──────────────────────────────────────── */
  function requiresDonorHarness(state) {
    return state.series === 'fg-mk2' || state.transmission === 'zf';
  }

  /* ── Classify a single variant into map keys ─────────────────── */
  /* Returns { series, mapTrans, mapPkg } where:
       series   = 'ba' | 'bf' | 'fg'
       mapTrans = 'zf' | 'manual'   (BTR and Manual share the same variant)
       mapPkg   = 'standard' | 'cruise' | 'turbo' | 'cruise-turbo'
     Returns null for unknown or OBD-extended variants. */
  function classifyVariant(variant, optionNames) {
    var opts = variant.options || [];
    if (!opts.length) return null;

    /* option1 = Series — BA, BF, FG (MK1), or FG MK2 */
    var series = opts[0].toLowerCase().trim();
    if (series === 'fg mk2') series = 'fg-mk2'; /* normalise Shopify option value */
    if (series !== 'ba' && series !== 'bf' && series !== 'fg' && series !== 'fg-mk2') return null;

    /* Find option2 = Package (skip OBD option) */
    var pkg_raw = null;
    for (var i = 1; i < opts.length; i++) {
      var oname = (optionNames[i] || '').toLowerCase();
      if (oname.indexOf('obd') !== -1 || oname.indexOf('lead') !== -1) continue;
      pkg_raw = opts[i].toLowerCase().trim();
      break;
    }
    if (pkg_raw === null) return null;

    /* Skip 2m Extended OBD variants (those are handled by the OBD checkbox) */
    for (var j = 0; j < opts.length; j++) {
      var onj = (optionNames[j] || '').toLowerCase();
      if ((onj.indexOf('obd') !== -1 || onj.indexOf('lead') !== -1) &&
          opts[j].toLowerCase().indexOf('extended') !== -1) {
        return null; /* skip — OBD checkbox handles the +$25 */
      }
    }

    /* Classify transmission and package from option2 */
    var mapTrans, mapPkg;
    if (pkg_raw.indexOf('zf') !== -1) {
      mapTrans = 'zf';
      mapPkg   = pkg_raw.indexOf('turbo') !== -1 ? 'turbo' : 'standard';
    } else {
      mapTrans = 'manual'; /* covers both Manual and BTR */
      var hasCruise = pkg_raw.indexOf('cruise') !== -1 || pkg_raw.indexOf('a/c') !== -1;
      var hasTurbo  = pkg_raw.indexOf('turbo') !== -1;
      if (hasCruise && hasTurbo) mapPkg = 'cruise-turbo';
      else if (hasCruise)        mapPkg = 'cruise';
      else if (hasTurbo)         mapPkg = 'turbo';
      else                       mapPkg = 'standard';
    }

    return { series: series, mapTrans: mapTrans, mapPkg: mapPkg };
  }

  /* ── Build variant lookup map ────────────────────────────────── */
  /* map[series][mapTrans][mapPkg] = variantId */
  function buildVariantMap(variants, optionNames) {
    var map = {};
    for (var i = 0; i < variants.length; i++) {
      var cl = classifyVariant(variants[i], optionNames);
      if (!cl) continue;
      if (!map[cl.series])                           map[cl.series] = {};
      if (!map[cl.series][cl.mapTrans])              map[cl.series][cl.mapTrans] = {};
      if (!map[cl.series][cl.mapTrans][cl.mapPkg]) {
        map[cl.series][cl.mapTrans][cl.mapPkg] = variants[i].id;
      }
    }
    return map;
  }

  /* ── Labels ──────────────────────────────────────────────────── */
  var TRANS_LABELS = {
    manual: 'Manual',
    btr:    'BTR Automatic',
    zf:     'ZF 6-Speed'
  };
  var PKG_LABELS = {
    standard:       'Standard',
    cruise:         'Cruise + A/C',
    turbo:          'Turbo Ready',
    'cruise-turbo': 'Cruise + A/C + Turbo'
  };
  /* ZF only has Standard and Turbo (Cruise/AC is always included) */
  var PKG_LABELS_ZF = {
    standard: 'Standard',
    turbo:    'Turbo Ready'
  };
  var PKG_KEYS_ZF    = ['standard', 'turbo'];
  var PKG_KEYS_NOZF  = ['standard', 'cruise', 'turbo', 'cruise-turbo'];

  /* ⓘ panel content */
  var SECTION_INFO = {
    series:
      '<p>Select the engine series that matches your Barra engine. BA and BF engines share many ' +
      'characteristics; FG engines differ in wiring and ECU architecture. <strong>FG MK2</strong> ' +
      '(from late 2011) introduced further changes and requires a section of the original factory ' +
      'Ford body harness to be supplied to GBS.</p>',
    trans:
      '<p>Select the transmission fitted to your target vehicle. <strong>Manual</strong> and ' +
      '<strong>BTR Automatic</strong> use the same harness wiring — your selection is recorded ' +
      'on your order for reference. <strong>ZF 6-Speed</strong> requires a dedicated wiring ' +
      'configuration and is only available for FG platform vehicles. A ZF body loom section must ' +
      'also be sent to GBS — a notice appears when ZF is selected.</p>',
    pkg:
      '<p>Choose the feature package for your harness. <strong>Standard</strong> suits most ' +
      'builds. Add <strong>Cruise + A/C</strong> to retain factory cruise control and air ' +
      'conditioning wiring. <strong>Turbo Ready</strong> variants include factory turbo sensor ' +
      'provisions. ZF 6-Speed builds always include cruise and A/C wiring — only Standard and ' +
      'Turbo Ready are offered.</p>'
  };

  /* ── Dawn variant radio selection ───────────────────────────── */
  /* Checks the radio inputs inside the variant-selects element that
     match the target variant's option values, then fires a change event
     so Dawn updates the price and availability. OBD radios are excluded
     so the customer's current OBD selection is preserved. */
  function selectDawnRadios(vsEl, optionValues) {
    /* Re-fetch live element by ID in case Dawn replaced it via AJAX section render */
    if (vsEl && vsEl.id) vsEl = document.getElementById(vsEl.id) || vsEl;
    if (!vsEl) return;
    var radios = vsEl.querySelectorAll(
      'input[type="radio"]:not([data-obd-standard]):not([data-obd-extended])'
    );
    var lastChanged = null;
    for (var i = 0; i < radios.length; i++) {
      var r = radios[i];
      if (optionValues.indexOf(r.value) !== -1 && !r.checked) {
        r.checked = true;
        lastChanged = r;
      }
    }
    if (!radios.length) {
      vsEl.dispatchEvent(new CustomEvent('change', { bubbles: true }));
      return;
    }
    var target = lastChanged || radios[0];
    target.dispatchEvent(new Event('change', { bubbles: true }));
  }

  /* ── Read Dawn's currently selected variant JSON ─────────────── */
  function readSelectedVariant(vsEl) {
    if (!vsEl) return null;
    var script = vsEl.querySelector('script[data-selected-variant]');
    if (!script) return null;
    try { return JSON.parse(script.textContent.trim()); } catch (e) { return null; }
  }

  /* ── HTML escape ─────────────────────────────────────────────── */
  function esc(s) {
    return String(s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  /* ── Lookup helpers ──────────────────────────────────────────── */
  function mapLookupTrans(uiTrans) {
    /* BTR and Manual both resolve to the 'manual' map key */
    return uiTrans === 'btr' ? 'manual' : uiTrans;
  }

  function availablePackages(map, series, uiTrans) {
    if (!series || !uiTrans) return {};
    var lt = mapLookupTrans(uiTrans);
    return (map[series] && map[series][lt]) ? map[series][lt] : {};
  }

  function lookupVariantId(map, series, uiTrans, pkg) {
    if (!series || !uiTrans || !pkg) return null;
    var lt = mapLookupTrans(uiTrans);
    return (map[series] && map[series][lt] && map[series][lt][pkg]) || null;
  }

  /* ================================================================
     GBSConfigurator CLASS
  ================================================================ */
  function GBSConfigurator(cfgData, vsEl) {
    this.sectionId   = cfgData.sectionId;
    this.optionNames = cfgData.options   || [];
    this.allVariants = cfgData.variants  || [];
    this.formId      = cfgData.formId;
    this.variantMap  = buildVariantMap(this.allVariants, this.optionNames);
    this.vsEl        = vsEl; /* the <variant-selects> element */
    this.state = {
      series:       null,   /* 'ba' | 'bf' | 'fg' | 'fg-mk2' */
      transmission: null,   /* 'manual' | 'btr' | 'zf' */
      package:      null    /* 'standard' | 'cruise' | 'turbo' | 'cruise-turbo' */
    };
    this._donorAcknowledged = false;
    this.cfgEl       = null;
    this.donorWarnEl = null;
    this.modalEl     = null;
  }

  GBSConfigurator.prototype.init = function () {
    this._buildModal();
    this._mountConfigurator();
    this._buildDonorWarning();
    this._interceptForm();
    this._preSelectFromDawn();
  };

  /* ── Mount: insert configurator div before variant-selects ──── */
  /* The original Dawn variant pickers (pill fieldsets, dropdowns,
     card fieldsets) are hidden purely by CSS in gbs-configurator.css
     using the [data-gbs-cfg] attribute selector. Pure-CSS hiding
     survives Dawn's per-variant AJAX innerHTML swap; JS-set hidden
     attributes do not. The OBD fieldset (.gbs-ph__obd) is not
     targeted by those CSS rules and stays visible. */
  GBSConfigurator.prototype._mountConfigurator = function () {
    var wrap = document.createElement('div');
    wrap.className = 'gbs-cfg';
    wrap.id = 'gbs-cfg-' + this.sectionId;
    this.vsEl.parentNode.insertBefore(wrap, this.vsEl);
    this.cfgEl = wrap;
    this._render();
  };

  /* ── Pre-select from Dawn's initial variant ──────────────────── */
  GBSConfigurator.prototype._preSelectFromDawn = function () {
    var vd = readSelectedVariant(this.vsEl);
    if (!vd || !vd.id) return;
    for (var i = 0; i < this.allVariants.length; i++) {
      var v = this.allVariants[i];
      if (v.id !== vd.id) continue;
      var cl = classifyVariant(v, this.optionNames);
      if (!cl) return;
      this.state.series       = cl.series;
      this.state.transmission = cl.mapTrans; /* 'manual' or 'zf' — BTR unknown at page load */
      this.state.package      = cl.mapPkg;
      this._render();
      return;
    }
  };

  /* ── Main render ─────────────────────────────────────────────── */
  GBSConfigurator.prototype._render = function () {
    var self = this;
    var s    = this.state;
    var map  = this.variantMap;
    var html = '';

    /* ── SECTION 1: ECU / Engine Series ─────────────────────── */
    var zfSelected = s.transmission === 'zf';
    /* ZF is only available for FG series — disable BA/BF when ZF is active */
    var seriesOptions = [
      { key: 'ba',     label: 'BA',     avail: !zfSelected && !!map['ba'] },
      { key: 'bf',     label: 'BF',     avail: !zfSelected && !!map['bf'] },
      { key: 'fg',     label: 'FG MK1', avail: !!map['fg'] },
      { key: 'fg-mk2', label: 'FG MK2', avail: !!map['fg-mk2'] }
    ];

    var SERIES_CHOSEN_LABELS = { 'ba': 'BA', 'bf': 'BF', 'fg': 'FG MK1', 'fg-mk2': 'FG MK2' };
    var seriesChosen = s.series ? (SERIES_CHOSEN_LABELS[s.series] || s.series.toUpperCase()) : null;

    var seriesBubbles = '<div class="gbs-cfg__bubbles">';
    seriesOptions.forEach(function (opt) {
      var isSel = s.series === opt.key;
      seriesBubbles +=
        '<button type="button"' +
        ' class="gbs-cfg__bubble' + (isSel ? ' is-sel' : '') + (opt.avail ? '' : ' is-unavail') + '"' +
        ' data-cfg-series="' + opt.key + '"' +
        (!opt.avail ? ' disabled' : '') + '>' +
        esc(opt.label) + '</button>';
    });
    seriesBubbles += '</div>';

    html += self._sectionCard({
      num: '1', id: 'series', title: 'ECU / Engine Series',
      infoKey: 'series', chosen: seriesChosen,
      locked: false, body: seriesBubbles
    });

    /* ── SECTION 2: Transmission ─────────────────────────────── */
    var transLocked = !s.series;
    /* ZF is only available for FG and FG MK2 series */
    var availTrans = ['manual', 'btr'];
    if (s.series === 'fg' || s.series === 'fg-mk2') availTrans.push('zf');

    var transBubbles = '<div class="gbs-cfg__bubbles">';
    ['manual', 'btr', 'zf'].forEach(function (tk) {
      var avail = !transLocked && availTrans.indexOf(tk) !== -1;
      var isSel = s.transmission === tk;
      transBubbles +=
        '<button type="button"' +
        ' class="gbs-cfg__bubble' + (isSel ? ' is-sel' : '') + (avail ? '' : ' is-unavail') + '"' +
        ' data-cfg-trans="' + tk + '"' +
        (!avail ? ' disabled' : '') + '>' +
        esc(TRANS_LABELS[tk]) + '</button>';
    });
    transBubbles += '</div>';

    html += self._sectionCard({
      num: '2', id: 'trans', title: 'Transmission',
      infoKey: 'trans',
      chosen: s.transmission ? TRANS_LABELS[s.transmission] : null,
      locked: transLocked, body: transBubbles
    });

    /* ── SECTION 3: Package ──────────────────────────────────── */
    var pkgLocked = !s.transmission;
    var isZf      = s.transmission === 'zf';
    var pkgKeys   = isZf ? PKG_KEYS_ZF : PKG_KEYS_NOZF;
    var pkgLabels = isZf ? PKG_LABELS_ZF : PKG_LABELS;
    var availPkg  = availablePackages(map, s.series, s.transmission);

    var pkgBubbles = '<div class="gbs-cfg__bubbles">';
    pkgKeys.forEach(function (pk) {
      var avail;
      if (pkgLocked) {
        avail = false;
      } else if (!Object.keys(availPkg).length) {
        avail = false; /* series+trans not yet fully selected */
      } else {
        avail = !!availPkg[pk];
      }
      var isSel = s.package === pk;
      pkgBubbles +=
        '<button type="button"' +
        ' class="gbs-cfg__bubble' + (isSel ? ' is-sel' : '') + (avail ? '' : ' is-unavail') + '"' +
        ' data-cfg-pkg="' + pk + '"' +
        (!avail ? ' disabled' : '') + '>' +
        esc(pkgLabels[pk]) + '</button>';
    });
    pkgBubbles += '</div>';

    if (isZf) {
      pkgBubbles +=
        '<p style="font-size:1.2rem;color:rgba(255,255,255,0.45);' +
        'margin:0.8rem 0 0;line-height:1.5">' +
        '&#10003;&nbsp;Cruise control and A/C wiring included as standard with ZF.</p>';
    }

    html += self._sectionCard({
      num: '3', id: 'pkg', title: 'Package',
      infoKey: 'pkg',
      chosen: s.package ? pkgLabels[s.package] : null,
      locked: pkgLocked, body: pkgBubbles
    });

    this.cfgEl.innerHTML = html;
    this._bindSectionListeners();
    this._updateDonorWarning();
  };

  /* ── Build one section card ──────────────────────────────────── */
  GBSConfigurator.prototype._sectionCard = function (opts) {
    var cls = 'gbs-cfg__section';
    if (opts.locked)      cls += ' is-locked';
    else if (opts.chosen) cls += ' is-complete';
    else                  cls += ' is-active';

    var infoId = 'gbs-cfg-info-' + this.sectionId + '-' + opts.id;
    var h = '<div class="' + cls + '">';
    h += '<div class="gbs-cfg__section-head">';
    h += '<span class="gbs-cfg__section-num">' + esc(opts.num) + '</span>';
    h += '<span class="gbs-cfg__section-title">' + esc(opts.title) + '</span>';
    if (opts.chosen) {
      h += '<span class="gbs-cfg__section-chosen">' + esc(opts.chosen) + '</span>';
    }
    h += '<button type="button" class="gbs-cfg__info-btn"' +
         ' data-cfg-info="' + infoId + '"' +
         ' aria-label="More information" title="More information">i</button>';
    h += '</div>';
    /* ⓘ expand panel */
    h += '<div class="gbs-cfg__info-panel" id="' + infoId + '">';
    h += '<div class="gbs-cfg__info-panel__inner">';
    h += '<div class="gbs-cfg__info-panel__body">' + (SECTION_INFO[opts.infoKey] || '') + '</div>';
    h += '</div></div>';
    /* option bubbles */
    if (!opts.locked) {
      h += '<div class="gbs-cfg__body">' + opts.body + '</div>';
    }
    h += '</div>';
    return h;
  };

  /* ── Bind section event listeners (re-run each render) ──────── */
  GBSConfigurator.prototype._bindSectionListeners = function () {
    var self = this;
    var root = this.cfgEl;

    /* ⓘ info buttons */
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-cfg-info]');
      if (!btn) return;
      var panelId = btn.getAttribute('data-cfg-info');
      var panel   = document.getElementById(panelId);
      if (!panel) return;
      var wasOpen = panel.classList.contains('is-open');
      root.querySelectorAll('.gbs-cfg__info-panel.is-open').forEach(function (p) {
        p.classList.remove('is-open');
      });
      root.querySelectorAll('.gbs-cfg__info-btn.is-open').forEach(function (b) {
        b.classList.remove('is-open');
      });
      if (!wasOpen) {
        panel.classList.add('is-open');
        btn.classList.add('is-open');
      }
    });

    /* Bubble clicks */
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-cfg-series],[data-cfg-trans],[data-cfg-pkg]');
      if (!btn) return;
      var s = self.state;

      if (btn.hasAttribute('data-cfg-series')) {
        var val = btn.getAttribute('data-cfg-series');
        s.series = val; /* 'ba' | 'bf' | 'fg' | 'fg-mk2' */
        /* BA/BF do not support ZF */
        if (s.transmission === 'zf' && s.series !== 'fg' && s.series !== 'fg-mk2') {
          s.transmission = null;
          s.package      = null;
        }
        /* Clear package if no longer valid for new series+trans */
        if (s.package && !self._pkgValid(s)) s.package = null;

      } else if (btn.hasAttribute('data-cfg-trans')) {
        var tk = btn.getAttribute('data-cfg-trans');
        if (tk === 'zf') {
          /* ZF requires FG or FG MK2 — if neither selected, default to FG */
          if (s.series !== 'fg' && s.series !== 'fg-mk2') {
            s.series = 'fg';
          }
        }
        s.transmission = tk;
        /* Reset package if no longer available for this transmission */
        if (s.package && !self._pkgValid(s)) s.package = null;
        /* Auto-select package if only one is available */
        var avPkg = availablePackages(self.variantMap, s.series, s.transmission);
        var avKeys = Object.keys(avPkg);
        /* For ZF: auto-select Standard if package not yet chosen */
        if (!s.package && tk === 'zf' && avPkg['standard']) s.package = 'standard';
        else if (!s.package && avKeys.length === 1) s.package = avKeys[0];

      } else if (btn.hasAttribute('data-cfg-pkg')) {
        s.package = btn.getAttribute('data-cfg-pkg');
      }

      self._render();
      self._maybeTriggerVariant();
    });
  };

  /* Is the current package still valid given current series+trans? */
  GBSConfigurator.prototype._pkgValid = function (s) {
    if (!s.package) return false;
    var avail = availablePackages(this.variantMap, s.series, s.transmission);
    return !!avail[s.package];
  };

  /* ── Trigger Dawn to select the correct Shopify variant ─────── */
  GBSConfigurator.prototype._maybeTriggerVariant = function () {
    var s = this.state;
    var vid = lookupVariantId(this.variantMap, s.series, s.transmission, s.package);
    if (!vid) return;

    /* Find the variant's raw option values */
    var target = null;
    for (var i = 0; i < this.allVariants.length; i++) {
      if (this.allVariants[i].id === vid) { target = this.allVariants[i]; break; }
    }
    if (!target) return;

    selectDawnRadios(this.vsEl, target.options);
    this._writeCartProperties();
  };

  /* ── Write cart properties for Series, Transmission, etc. ────── */
  GBSConfigurator.prototype._writeCartProperties = function () {
    var s    = this.state;
    var form = document.getElementById(this.formId);
    if (!form) return;

    /* Engine Series — always written so GBS knows exact customer choice */
    var SERIES_LABELS = { 'ba': 'BA', 'bf': 'BF', 'fg': 'FG MK1', 'fg-mk2': 'FG MK2' };
    var seriesLabel = s.series ? (SERIES_LABELS[s.series] || s.series.toUpperCase()) : '';
    this._upsertProp(form, 'gbs-prop-series-' + this.sectionId,
      'properties[Engine Series]', seriesLabel, !!seriesLabel);

    /* Transmission — always written */
    var transLabel = s.transmission ? (TRANS_LABELS[s.transmission] || '') : '';
    this._upsertProp(form, 'gbs-prop-trans-' + this.sectionId,
      'properties[Transmission]', transLabel, !!transLabel);
  };

  GBSConfigurator.prototype._upsertProp = function (form, id, name, value, enabled) {
    var el = document.getElementById(id);
    if (!el) {
      el = document.createElement('input');
      el.type = 'hidden';
      el.id   = id;
      el.name = name;
      form.appendChild(el);
    }
    el.value    = value;
    el.disabled = !enabled;
  };

  /* ── Donor harness warning ───────────────────────────────────── */
  GBSConfigurator.prototype._buildDonorWarning = function () {
    var self = this;
    var el = document.createElement('div');
    el.id = 'gbs-cfg-donor-' + this.sectionId;
    el.className = 'gbs-cfg__donor-warn';
    el.innerHTML =
      '<span class="gbs-cfg__donor-warn-icon">&#9888;&#65039;</span>' +
      '<div class="gbs-cfg__donor-warn-body">' +
        '<p class="gbs-cfg__donor-warn-title">Factory body harness section required</p>' +
        '<p class="gbs-cfg__donor-warn-sub">' +
          'A section of the original Ford factory body harness must be sent to GBS before ' +
          'your harness can be built.' +
        '</p>' +
        '<div class="gbs-cfg__donor-info-panel" id="gbs-cfg-donor-info-' + this.sectionId + '">' +
          '<p>FG MK2 and ZF 6-speed configurations require a section of the original factory ' +
          'Ford body harness to be supplied to Greens Barra Solutions.</p>' +
          '<p>If you do not have the required section, please contact GBS before ordering. ' +
          'We may be able to supply the required component depending on availability; however, ' +
          'an additional fee will apply.</p>' +
        '</div>' +
      '</div>' +
      '<button type="button" class="gbs-cfg__donor-info-btn"' +
      ' data-donor-info-btn title="More information">i</button>';

    /* Insert after the configurator div */
    this.cfgEl.parentNode.insertBefore(el, this.cfgEl.nextSibling);
    this.donorWarnEl = el;

    el.querySelector('[data-donor-info-btn]').addEventListener('click', function () {
      var p = document.getElementById('gbs-cfg-donor-info-' + self.sectionId);
      if (p) p.classList.toggle('is-open');
    });
  };

  GBSConfigurator.prototype._updateDonorWarning = function () {
    if (!this.donorWarnEl) return;
    this.donorWarnEl.classList.toggle('is-visible', requiresDonorHarness(this.state));
  };

  /* ── Acknowledgement modal ───────────────────────────────────── */
  GBSConfigurator.prototype._buildModal = function () {
    var self = this;
    var bg = document.createElement('div');
    bg.className = 'gbs-cfg__modal-bg';
    bg.id = 'gbs-cfg-modal-' + this.sectionId;
    bg.innerHTML =
      '<div class="gbs-cfg__modal" role="dialog" aria-modal="true"' +
      ' aria-labelledby="gbs-cfg-modal-title-' + this.sectionId + '">' +
        '<div class="gbs-cfg__modal-head">' +
          '<div class="gbs-cfg__modal-icon">&#9888;&#65039;</div>' +
          '<h2 class="gbs-cfg__modal-title" id="gbs-cfg-modal-title-' + this.sectionId + '">' +
            'Factory Harness Required' +
          '</h2>' +
        '</div>' +
        '<div class="gbs-cfg__modal-body">' +
          '<p>Your selected configuration requires a section of the original factory Ford body ' +
          'harness to be supplied to Greens Barra Solutions.</p>' +
          '<p>If you do not have the required harness section, please contact us before ' +
          'ordering. We may be able to supply it depending on availability for an additional fee.</p>' +
        '</div>' +
        '<div class="gbs-cfg__modal-actions">' +
          '<button type="button" class="gbs-cfg__modal-confirm" data-cfg-modal-confirm>' +
            'I Understand — Add to Cart' +
          '</button>' +
          '<a href="' + CONTACT_URL + '" class="gbs-cfg__modal-contact">Contact GBS</a>' +
        '</div>' +
      '</div>';

    document.body.appendChild(bg);
    this.modalEl = bg;

    bg.querySelector('[data-cfg-modal-confirm]').addEventListener('click', function () {
      self._closeModal();
      self._setAcknowledgement(true);
      self._donorAcknowledged = true;
      var form = document.getElementById(self.formId);
      if (form) form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    });

    bg.addEventListener('click', function (e) {
      if (e.target === bg) self._closeModal();
    });
  };

  GBSConfigurator.prototype._showModal = function () {
    if (!this.modalEl) return;
    this.modalEl.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    var btn = this.modalEl.querySelector('[data-cfg-modal-confirm]');
    if (btn) setTimeout(function () { btn.focus(); }, 80);
  };

  GBSConfigurator.prototype._closeModal = function () {
    if (!this.modalEl) return;
    this.modalEl.classList.remove('is-open');
    document.body.style.overflow = '';
  };

  GBSConfigurator.prototype._setAcknowledgement = function (ack) {
    var ackId = 'gbs-cfg-donor-ack-' + this.sectionId;
    var form  = document.getElementById(this.formId);
    this._upsertProp(form, ackId,
      'properties[Factory Harness Requirement]',
      ack ? 'Customer Acknowledged' : '', ack);
  };

  /* ── Add-to-cart intercept ───────────────────────────────────── */
  GBSConfigurator.prototype._interceptForm = function () {
    var self = this;
    var form = document.getElementById(this.formId);
    if (!form) return;
    form.addEventListener('submit', function (e) {
      if (!requiresDonorHarness(self.state)) return;
      if (self._donorAcknowledged) { self._donorAcknowledged = false; return; }
      e.preventDefault();
      e.stopImmediatePropagation();
      self._showModal();
    }, true /* capture so we run before Dawn's submit handler */);
  };

  /* ================================================================
     ADD-ON ⓘ BUTTONS
     Collapse OBD and Digital Dash descriptions behind info buttons.
  ================================================================ */
  function initAddonInfoButtons(sectionId) {
    [
      {
        wrapSel: '.gbs-obd-checkbox-label',
        textSel: '.gbs-obd-checkbox-text',
        descSel: '.gbs-obd-desc',
        id: 'obd'
      },
      {
        wrapSel: '.gbs-adash-checkbox-label',
        textSel: '.gbs-adash-checkbox-text',
        descSel: '.gbs-adash-desc',
        id: 'adash'
      }
    ].forEach(function (pair) {
      var wrap = document.querySelector(pair.wrapSel);
      if (!wrap) return;
      var textEl = wrap.querySelector(pair.textSel);
      var descEl = wrap.querySelector(pair.descSel);
      if (!textEl || !descEl) return;

      var descContent = descEl.innerHTML;
      descEl.style.display = 'none';

      /* ⓘ button appended to the label text span */
      var btn = document.createElement('button');
      btn.type      = 'button';
      btn.className = 'gbs-addon-info-btn';
      btn.title     = 'More information';
      btn.innerHTML = 'i';
      textEl.appendChild(btn);

      /* Expandable panel inserted after the label */
      var panel = document.createElement('div');
      panel.className = 'gbs-addon-info-panel';
      panel.id = 'gbs-addon-info-' + pair.id + '-' + sectionId;
      panel.innerHTML =
        '<div class="gbs-addon-info-inner">' +
          '<div class="gbs-addon-info-body">' + descContent + '</div>' +
        '</div>';
      wrap.parentNode.insertBefore(panel, wrap.nextSibling);

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var open = panel.classList.toggle('is-open');
        btn.style.borderColor = open ? 'rgba(106,176,48,0.5)' : '';
        btn.style.color       = open ? '#6ab030' : '';
      });
    });
  }

  /* ================================================================
     AUTO-INIT
  ================================================================ */
  function autoInit() {
    document.querySelectorAll('[data-gbs-cfg]').forEach(function (vsEl) {
      var sid    = vsEl.getAttribute('data-gbs-cfg');
      var dataEl = document.getElementById('gbs-cfg-data-' + sid);
      if (!dataEl) return;

      var cfgData;
      try { cfgData = JSON.parse(dataEl.textContent.trim()); } catch (e) { return; }
      if (!cfgData.variants || cfgData.variants.length < 2) return;

      /* Only activate for harness products — map must contain ba/bf/fg series */
      var map = buildVariantMap(cfgData.variants, cfgData.options || []);
      var hasHarnessSeries = ['ba', 'bf', 'fg', 'fg-mk2'].some(function (s) { return !!map[s]; });
      if (!hasHarnessSeries) return;

      var cfg = new GBSConfigurator(cfgData, vsEl);
      cfg.init();
      initAddonInfoButtons(sid);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', autoInit);
  } else {
    autoInit();
  }

})();
